<script lang="ts" setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useTask } from "@/stores/task";
import { computed } from "vue";
import { isEditTraitAction } from "./action";

const { btn, isIcon, extraClass, icon, id } = defineProps({
  id: {
    type: Number,
    required: true,
  },
  isIcon: {
    type: Boolean,
    default: false,
  },
  extraClass: {
    type: String,
    default: "primary",
  },
  btn: {
    type: String,
    required: true,
  },
  icon: {
    type: String,
  },
});

const taskStore = useTask();
const emit = defineEmits(["onClickBtn"]);

const text = computed(() => {
  let _text = btn;
  const task = taskStore.getTask(id);
  // 覆盖原特征
  if (isEditTraitAction(task!, btn)) _text = "emoji1";
  return t(`task.btn.${_text}`);
});

const { t } = useI18n();

onMounted(() => {});
</script>

<template>
  <button
    :class="[
      'btn-xs rounded font-normal h-8 flex flex-nowrap justify-center items-center px-[0.3rem]',
      isIcon && 'w-8 btn',
      extraClass,
      !isIcon && btn === 'more' && 'btn  flex-1',
    ]"
    @click.stop="emit('onClickBtn', btn)"
    @touchstart.stop
    @touchend.stop
    @mousedown.stop
    @mouseup.stop
  >
    <i :class="`iconfont icon-${icon || btn}`" />
    <span v-if="!isIcon">{{ text }}</span>
  </button>
</template>
